export default __webpack_public_path__ + "static/media/cocktail5.99015630.jpg";